import Layout from '@/components/common/Layout.vue'
import Home from '@/components/pages/Home'
import LoginPage from '@/components/pages/LoginPage'
import LeaseListPage from '@/components/pages/LeaseListPage'
import LeaseDetailPage from '@/components/pages/LeaseDetailPage'
import LeasePriceListPage from '@/components/pages/LeasePriceListPage'
import LogisticsListPage from '@/components/pages/Logistics/LogisticsListPage'
import LogisticsDetailPage from '@/components/pages/Logistics/LogisticsDetailPage'
import LeaseSendListPage from '@/components/pages/Logistics/LeaseSendListPage'
import ProfilePage from '@/components/pages/ProfilePage'
import CustomerInfoModule from '@/components/pages/ProfilePage/CustomerInfoModule'
import CustomerPointModule from '@/components/pages/ProfilePage/CustomerPointModule'
import EngineerModule from '@/components/pages/ProfilePage/EngineerModule'
import RepairListPage from '@/components/pages/Repair/RepairListPage'
import RepairDetailPage from '@/components/pages/Repair/RepairDetailPage'
import NewRepairPage from '@/components/pages/Repair/NewRepairPage'
import LeaseSentOrder from '@/components/pages/Order/LeaseSent_order'
import LeaseSentDetailOrder from '@/components/pages/Order/LeaseSentDetail_order'
import PurchaseOrder from '@/components/pages/Order/Purchase_order'
import PurchaseDetailOrder from '@/components/pages/Order/PurchaseDetail_order'
import DispatchOrder from '@/components/pages/Order/Dispatch_order'
import DispatchDetailOrder from '@/components/pages/Order/DispatchDetail_order'
import EntrustOrder from '@/components/pages/Order/Entrust_order'
import EntrustDetailOrder from '@/components/pages/Order/EntrustDetail_order'
import RepairPricePage from '@/components/pages/Repair/RepairPricePage'
import TrustListPage from '@/components/pages/Inventory/TrustListPage'
import ManagedListPage from '@/components/pages/Inventory/ManagedListPage'
import TrustDetailPage from '@/components/pages/Inventory/TrustDetailPage'
import ManagedLeaseDetail from '@/components/pages/Inventory/ManagedLeaseDetail'
import ManagedSelfDetail from '@/components/pages/Inventory/ManagedSelfDetail'
import ManagedAllDetail from '@/components/pages/Inventory/ManagedAllDetail'
import LeaseApplyPage from '@/components/pages/Inventory/LeaseApplyPage'
import TrustApplyPage from '@/components/pages/Inventory/TrustApplyPage'
import TrustActivePage from '@/components/pages/Inventory/TrustActivePage'
import PurchasePage from '@/components/pages/Inventory/PurchasePage'
import ManagedApplyPage from '@/components/pages/Inventory/ManagedApplyPage'
import NewShipPage from '@/components/pages/Inventory/NewShipPage'
import ManagedShipPage from '@/components/pages/Inventory/ManagedShipPage'
import EntrustListPage from '@/components/pages/Entrust/EntrustListPage'
import EntrustLeasePage from '@/components/pages/Entrust/EntrustLeasePage'
import EntrustSellPage from '@/components/pages/Entrust/EntrustSellPage'
import EntrustDetailPage from '@/components/pages/Entrust/EntrustDetailPage'
import DepositStatement from '@/components/pages/Financial/Deposit_statement'
import DepositDetail from '@/components/pages/Financial/DepositDetail'
import EntrustedIncomeStatement from '@/components/pages/Financial/EntrustedIncome_statement'
import EntrustedSaleStatement from '@/components/pages/Financial/EntrustedSale_statement'
import EscrowExpenditureStatement from '@/components/pages/Financial/EscrowExpenditure_statement'
import LeaseExpenditureStatement from '@/components/pages/Financial/LeaseExpenditure_statement'
import LogisticsExpenditureStatement from '@/components/pages/Financial/LogisticsExpenditure_statement'
import RepairExpenditureStatement from '@/components/pages/Financial/RepairExpenditure_statement'
import Help from '@/components/pages/Help'
import HelpListPage from '@/components/pages/Help/HelpListPage'
import ArticleListPage from '@/components/pages/Articles/ArticleListPage'
import ArticleDetail from '@/components/pages/Articles/ArticleDetail'
let routes = [
  {
    path: '/',
    component: Layout,
    children: [
      /* 首页 */
      {
        path: '',
        component: Home,
      },
      /* 最新动态列表 */
      {
        path: '/Articles',
        name: 'ArticleListPage',
        component: ArticleListPage,
        meta: {
          title: '最新动态',
        },
      },
      {
        path: '/Articles/:tabs',
        name: 'ArticleListPage',
        component: ArticleListPage,
        meta: {
          title: '最新动态',
        },
      },
      {
        path: '/Article/:id',
        name: 'ArticleDetail',
        component: ArticleDetail,
        meta: {
          title: '最新动态',
        },
      },
      /* 帮助中心 Help */
      {
        path: '/help',
        component: Help,
      },
      /* 帮助列表 HelpListPage */
      {
        path: '/helpList',
        component: HelpListPage,
      },
      {
        path: '/helpList/:SearchWords',
        component: HelpListPage,
      },
      /* 委托查询 Entrust page */
      {
        path: '/entrust',
        name: 'EntrustList',
        component: EntrustListPage,
      },
      {
        path: '/entrust/:id',
        name: 'EntrustDetail',
        component: EntrustDetailPage,
      },
      {
        path: '/entrust_lease',
        name: 'EntrustLease',
        component: EntrustLeasePage,
      },
      {
        path: '/entrust_sell',
        name: 'EntrustSell',
        component: EntrustSellPage,
      },
      /* 个人中心 profile page */
      {
        path: 'profile',
        component: ProfilePage,
        children: [
          { path: 'info', component: CustomerInfoModule },
          { path: 'point', component: CustomerPointModule },
          { path: 'engineer', component: EngineerModule },
          { path: '', redirect: 'info' },
        ],
      },
      /* 租赁 lease page */
      {
        path: 'lease',
        name: 'LeaseList',
        component: LeaseListPage,
      },
      {
        path: 'lease/:id',
        name: 'LeaseDetail',
        component: LeaseDetailPage,
      },
      {
        path: 'leaseprice',
        name: 'LeasePriceList',
        component: LeasePriceListPage,
      },
      /* 财务 financial page */
      {
        path: '/escrowExpenditure_statement',
        name: 'EscrowExpenditureStatement',
        component: EscrowExpenditureStatement,
      },
      {
        path: '/leaseExpenditure_statement',
        name: 'LeaseExpenditureStatement',
        component: LeaseExpenditureStatement,
      },
      {
        path: '/logisticsExpenditure_statement',
        name: 'LogisticsExpenditureStatement',
        component: LogisticsExpenditureStatement,
      },
      {
        path: '/repairExpenditure_statement',
        name: 'RepairExpenditureStatement',
        component: RepairExpenditureStatement,
      },
      {
        path: '/financial',
        name: 'EntrustedIncomeStatement',
        component: EntrustedIncomeStatement,
      },
      {
        path: '/entrustedIncome_statement',
        name: 'EntrustedIncomeStatement',
        component: EntrustedIncomeStatement,
      },
      {
        path: '/deposit_statement',
        name: 'DepositStatement',
        component: DepositStatement,
      },
      {
        path: '/depositDetail/:id',
        name: 'DepositDetail',
        component: DepositDetail,
      },
      {
        path: '/entrustedSale_statement',
        name: 'EntrustedSaleStatement',
        component: EntrustedSaleStatement,
      },
      /* 订单 order page */
      {
        path: '/order',
        name: 'LeaseSentOrder',
        component: LeaseSentOrder,
      },
      {
        path: '/leaseSent_order',
        name: 'LeaseSentOrder',
        component: LeaseSentOrder,
      },
      {
        path: '/leaseSent_order/:id',
        name: 'LeaseSentDetailOrder',
        component: LeaseSentDetailOrder,
      },
      {
        path: '/purchase_order',
        name: 'PurchaseOrder',
        component: PurchaseOrder,
      },
      {
        path: '/purchase_order/:id',
        name: 'PurchaseDetailOrder',
        component: PurchaseDetailOrder,
      },
      {
        path: '/dispatch_order',
        name: 'DispatchOrder',
        component: DispatchOrder,
      },
      {
        path: '/dispatch_order/:id',
        name: 'DispatchDetailOrder',
        component: DispatchDetailOrder,
      },
      {
        path: '/entrust_order',
        name: 'EntrustOrder',
        component: EntrustOrder,
      },
      {
        path: '/entrust_order/:id',
        name: 'EntrustDetailOrder',
        component: EntrustDetailOrder,
      },
      /* 库存 inventory page */
      {
        path: '/managed_ship',
        name: 'ManagedShip',
        component: ManagedShipPage,
      },
      {
        path: '/trust_apply',
        name: 'TrustApply',
        component: TrustApplyPage,
      },
      {
        path: '/trust_active',
        name: 'TrustActive',
        component: TrustActivePage,
      },
      {
        path: '/newship',
        name: 'NewShip',
        component: NewShipPage,
      },
      {
        path: '/lease_apply',
        name: 'LeaseApply',
        component: LeaseApplyPage,
      },
      {
        path: '/managed_apply',
        name: 'ManagedApply',
        component: ManagedApplyPage,
      },
      {
        path: '/purchase',
        name: 'Purchase',
        component: PurchasePage,
      },
      {
        path: '/trust',
        name: 'TrustList',
        component: TrustListPage,
      },
      {
        path: '/inventory',
        name: 'TrustList',
        component: TrustListPage,
      },
      {
        path: '/trust/:ConditionId&:ProductId&:lotType',
        name: 'TrustDetail',
        component: TrustDetailPage,
      },
      {
        path: '/managed',
        name: 'ManagedList',
        component: ManagedListPage,
      },
      {
        path: '/managedlease/:ConditionId&:ProductId',
        name: 'ManagedLeaseDetail',
        component: ManagedLeaseDetail,
      },
      {
        path: '/managedself/:ConditionId&:ProductId',
        name: 'ManagedSelfDetail',
        component: ManagedSelfDetail,
      },
      {
        path: '/managedall/:ConditionId&:ProductId',
        name: 'ManagedAllDetail',
        component: ManagedAllDetail,
      },
      /* 维修 repair page */
      {
        path: '/repair',
        name: 'RepairList',
        component: RepairListPage,
      },
      {
        path: '/repair/:id',
        name: 'RepairDetail',
        component: RepairDetailPage,
      },
      {
        path: '/newrepair',
        name: 'NewRepair',
        component: NewRepairPage,
      },
      {
        path: '/repairprice',
        name: 'RepairPrice',
        component: RepairPricePage,
      },
      /* 物流 logistics page */
      {
        path: '/logistics',
        name: 'LogisticsList',
        component: LogisticsListPage,
      },
      {
        path: '/logistics/:id',
        name: 'LogisticsDetail',
        component: LogisticsDetailPage,
      },
      {
        path: '/leaseSend',
        name: 'LeaseSendList',
        component: LeaseSendListPage,
      },
    ],
  },
  {
    path: '/login',
    component: LoginPage,
  },
  {
    path: '*',
    redirect: '/',
  },
]
export default routes



// WEBPACK FOOTER //
// ./src/router/routes.js